import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Seperator } from 'framework/Input/components/Seperator';

import { useFieldTheme } from '../../field/hooks/useFieldTheme';

import cn from './Component.module.scss';

export const Loading = () => {
  const { color } = useFieldTheme();
  return (
    <>
      <div className={cn.loader} style={{ color: color.disabled }}>
        <FontAwesomeIcon icon={faCircle} />
        <FontAwesomeIcon icon={faCircle} />
        <FontAwesomeIcon icon={faCircle} />
      </div>
      <Seperator background={color.disabled} />
    </>
  );
};
